/* Layout */
import Layout from '@/layout'
import page404 from '@/views/error-page/404'

/**
 *  视图映射表
 */
export default {
  'layout/Layout': Layout,
  'views/help/index': () => import('@/views/help/index'),
  // 二级菜单
  'layout/subLayout': () => import('@/layout/sub-layout/index'),
  'views/dashboard/index': () => import('@/views/dashboard/index'),
  'views/dashboard/statistical-analysis/index': () => import('@/views/statistical-analysis/index'),
  'views/settings/index': () => import('@/views/settings/index'),
  'views/settings/app': () => import('@/views/settings/app.vue'),
  'views/settings/storage': () => import('@/views/settings/storage.vue'),
  'views/settings/wechat': () => import('@/views/settings/wechat.vue'),
  'views/settings/sms': () => import('@/views/settings/sms.vue'),
  'views/settings/secure': () => import('@/views/settings/secure.vue'),
  'views/settings/mail': () => import('@/views/settings/mail.vue'),
  'views/settings/gateway': () => import('@/views/settings/gateway.vue'),
  'views/settings/login-log': () => import('@/views/logs/login-log'),
  'views/settings/operation-log': () => import('@/views/logs/operation-log'),
  'views/permission/user/index': () => import('@/views/permission/user/index'),
  'views/permission/role/index': () => import('@/views/permission/role/index'),
  'views/permission/menu/index': () => import('@/views/permission/menu/index'),
  'views/permission/post/index': () => import('@/views/permission/post/index'),
  'views/permission/user-group/index': () => import('@/views/permission/user-group/index'),
  'views/base-info/index': () => import('@/views/base-info/index'),
  'views/base-info/land/index': () => import('@/views/base-info/land/index'),
  'views/base-info/block/index': () => import('@/views/base-info/block/index'),
  'views/table/index': () => import('@/views/table/index'),
  'views/tree/index': () => import('@/views/tree/index'),
  'views/form/index': () => import('@/views/form/index'),
  // 'views/nested/menu1/index': () => import('@/views/nested/menu1/index'),
  // 'views/nested/menu1/menu1-1': () => import('@/views/nested/menu1/menu1-1'),
  // 'views/nested/menu1/menu1-2': () => import('@/views/nested/menu1/menu1-2'),
  // 'views/nested/menu1/menu1-2/menu1-2-1': () => import('@/views/nested/menu1/menu1-2/menu1-2-1'),
  // 'views/nested/menu1/menu1-2/menu1-2-2': () => import('@/views/nested/menu1/menu1-2/menu1-2-2'),
  // 'views/nested/menu1/menu1-3': () => import('@/views/nested/menu1/menu1-3'),
  // 'views/nested/menu2/index': () => import('@/views/nested/menu2/index'),
  'views/device/control/index': () => import('@/views/device/control/index'),
  'views/device/library/index': () => import('@/views/device/library/index'),
  'views/device/weather-station/index': () =>
    import('@/views/device/weather-station/index'),
  'views/device/soli/index': () => import('@/views/device/soli/index'),
  'views/device/pest/index': () => import('@/views/device/pest/index'),
  'views/device/camera/index': () => import('@/views/device/camera/index'),
  'views/device/smart/index': () => import('@/views/device/smart/index'),
  'views/device/warning/index': () => import('@/views/device/warning/index'),
  'views/device/iotcode/index': () => import('@/views/device/iotcode/index'),
  'views/enterprise/agents/index': () =>
    import('@/views/enterprise/agents/index'),
  'views/enterprise/workflow': () =>
    import('@/views/enterprise/workflow/index'),
  'views/enterprise/manager/index': () =>
    import('@/views/enterprise/manager/index'),
  'views/enterprise/post/index': () => import('@/views/enterprise/post/index'),
  'views/enterprise/supplier/index': () =>
    import('@/views/enterprise/supplier/index'),
  'views/center-data/weather': () =>
    import('@/views/center-data/weather/index'),
  'views/center-data/pest': () => import('@/views/center-data/pest/index'),
  'views/center-data/ai': () => import('@/views/center-data/ai/index'),
  'views/center-data/soil': () => import('@/views/center-data/soil/index'),
  'views/center-data/video': () => import('@/views/center-data/video/index'),
  'views/center-data/warning': () =>
    import('@/views/center-data/warning/index'),
  'views/center-data/smart': () => import('@/views/center-data/smart/index'),
  'views/center-data/history': () =>
    import('@/views/center-data/history/index'),
  'views/production/activity': () =>
    import('@/views/production/activity/index'),
  'views/production/farming-behavior': () =>
    import('@/views/production/farming-behavior/index'),
  'views/production/inputs': () => import('@/views/production/inputs/index'),
  'views/production/inputs-catalog': () =>
    import('@/views/production/inputs-catalog/index'),
  'views/production/production-plan': () =>
    import('@/views/production/production-plan/index'),
  'views/products/catalog': () => import('@/views/products/catalog/index'),
  'views/products/data': () => import('@/views/products/data/index'),
  'views/products/packaging': () => import('@/views/products/packaging/index'),
  'views/products/specification': () =>
    import('@/views/products/specification/index'),
  'views/products/testing': () => import('@/views/products/testing/index'),
  'views/trace/batch': () => import('@/views/trace/batch/index'),
  'views/trace/packing': () => import('@/views/trace/packing/index'),
  'views/trace/histories': () => import('@/views/trace/histories/index'),
  'views/trace/track': () => import('@/views/trace/track/index'),
  'views/trace/report': () => import('@/views/trace/report/index'),
  'views/psi/library-operation': () =>
    import('@/views/psi/library-operation/index'),
  'views/psi/library-type': () => import('@/views/psi/library-type/index'),
  'views/psi/warehouse': () => import('@/views/psi/warehouse/index'),
  'views/psi/goods': () => import('@/views/psi/goods/index'),
  'views/psi/purchase-plan': () => import('@/views/psi/purchase-plan/index'),
  'views/psi/purchase-contract': () =>
    import('@/views/psi/purchase-contract/index'),
  'views/psi/sale': () => import('@/views/psi/sale/index'),
  'views/psi/sale-contract': () => import('@/views/psi/sale-contract/index'),
  'views/psi/psi-statistic': () => import('@/views/psi/psi-statistic/index'),
  'views/psi/goods-statistics': () =>
    import('@/views/psi/goods-statistics/index'),
  // 消息队列
  'views/horizon/dashboard': () => import('@/views/horizon/dashboard'), // 面板
  'views/horizon/metrics': () => import('@/views/horizon/metrics/index'), // 性能
  'views/horizon/metrics/preview': () =>
    import('@/views/horizon/metrics/preview'), // 图表数据
  'views/horizon/monitoring': () => import('@/views/horizon/monitoring/index'), // 标签监视
  'views/horizon/monitoring/tag-jobs': () =>
    import('@/views/horizon/monitoring/tag-jobs'), // 监视详情
  'views/horizon/recentJobs/index': () =>
    import('@/views/horizon/recentJobs/index'), // 已完成
  'views/horizon/recentJobs/job': () =>
    import('@/views/horizon/recentJobs/job'),
  'views/horizon/pendingJobs/index': () =>
    import('@/views/horizon/pendingJobs/index'), // 进行中
  'views/horizon/pendingJobs/job': () =>
    import('@/views/horizon/pendingJobs/job'),
  'views/horizon/failedJobs/index': () =>
    import('@/views/horizon/failedJobs/index'), // 失败任务
  'views/horizon/failedJobs/job': () =>
    import('@/views/horizon/failedJobs/job'), // 失败任务详情，
  'views/cms/item-cate': () => import('@/views/cms/item-cate/index'),
  'views/cms/article': () => import('@/views/cms/article/index'),
  'views/cms/single-page': () => import('@/views/cms/single-page/index'),
  'views/cms/message': () => import('@/views/cms/message/index'),
  // 物联管理-数据报表管理-采集数据报表
  'views/center-data-report/report': () => import('@/views/center-data/collect-data-report/index'),
  'views/center-data-report/farm': () => import('@/views/center-data/collect-data-report/farm-report'),
  'views/permission/corp-type': () => import('@/views/permission/corp-type/index'),
  'views/permission/corp': () => import('@/views/permission/corp/index'),
  // AI助手
  'views/ai-assistant/ai-message': () => import('@/views/ai-assistant/ai-message/index'),
  //可视化大屏-主题类型
  'views/screen/type': () => import('@/views/screen/type/index'),
   //可视化大屏-主题管理
  'views/screen/theme': () => import('@/views/screen/theme/index'),
  '404-page': page404
}
